import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=679b3552&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=679b3552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b3552",
  null
  
)

export default component.exports